export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const METAFIELDS_NAMESPACE = "dmoda_sync";
export const SETTINGS_NAMESPACE = "settings";
export const SETTINGS_KEY_DMODA = "dmoda";
export const SETTINGS_PRODUCT_IMPORT_KEY_DMODA = "dmoda-product-import";
export const SETTINGS_PRICE_IMPORT_KEY_DMODA = "dmoda-price-import";
export const SETTINGS_RMA_KEY_DMODA = "dmoda-rma";
export const METAFIELDS_CUSTOM_NAMESPACE = "custom";
